import React, { Component } from "react";

import _service from '@netuno/service-client';

import "./index.less";

import Loading from "../Loading/index.jsx";
import Core from '../../Core';

export default class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      phone: '',
      whatsapp: '',
      email: '',
      submitted: false,
      error: false,
      loading: false,
      isModalVisible: false,
      requiredAlert: ["name"],
      invalidEmail: false,
      phoneIsWhatsapp: true,
      invalidPhone: false,
      invalidWhatsapp: false,
      phoneOrWhatsappOrMailMessage: true
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleModalShow = this.handleModalShow.bind(this);
    this.handleModalHide = this.handleModalHide.bind(this);
  }


  componentWillUnmount() {
  }

  handleInputChange(event) {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;

    if (target.name === "phone" || target.name === "whatsapp") {
      if (!/^[0-9.]+$/.test(value) && value !== "") {
        return
      }

      if ((!/[0-9]{9}$/.test(value) && target.name === "phone") && value !== "") {
        this.setState({ invalidPhone: true })
      } else if (target.name === "phone") {
        this.setState({ invalidPhone: false })
      }

      if ((!/[0-9]{9}$/.test(value) && target.name === "whatsapp") || (this.state.phoneIsWhatsapp && (!/[0-9]{9}$/.test(value) && target.name === "phone") && value !== "")) {
        this.setState({ invalidWhatsapp: true })
      } else if (target.name === "whatsapp" || (target.name === "phone" && this.state.phoneIsWhatsapp)) {
        this.setState({ invalidWhatsapp: false })
      }

      if (target.name === "whatsapp" && value === "") {
        this.setState({ invalidWhatsapp: false })
      }

      if (target.name === "whatsapp") this.setState({ phoneIsWhatsapp: false })
    }

    if (value.trim() === "" && target.name !== "email") this.setState({ requiredAlert: [...this.state.requiredAlert, target.name] })
    else this.setState({ requiredAlert: this.state.requiredAlert.filter(field => field !== target.name) })

    if (target.name === "email" && value.trim() !== "" && !/\S+@\S+\.\S+/.test(value)) this.setState({ invalidEmail: true })
    else this.setState({ invalidEmail: false })

    this.setState({
      [name]: value
    });

    if (this.state.phoneIsWhatsapp && target.name === "phone") {
      this.setState({ whatsapp: value })
    }

    if (
      (target.name === "email" && this.state.phone === "" && this.state.whatsapp === "" && target.value === "") ||
      (target.name === "phone" && this.state.email === "" && this.state.whatsapp === "" && target.value === "") ||
      (target.name === "phone" && this.state.email === "" && this.state.phoneIsWhatsapp && target.value === "") ||
      (target.name === "whatsapp" && this.state.email === "" && this.state.phone === "" && target.value === "")) {
      this.setState({
        phoneOrWhatsappOrMailMessage: true
      })
    } else if (target.name === "email" || target.name === "phone" || target.name === "whatsapp") {
      this.setState({
        phoneOrWhatsappOrMailMessage: false
      })
    }
  }

  handleSubmit(event) {
    console.log("Submited")
    event.preventDefault();
    const { name, phone, whatsapp, email } = this.state;
    const fields = { name, phone, whatsapp, email }
    const empityFields = []
    let submit = true
    Object.keys(fields).forEach(field => {
      if (fields[field].trim() === "" && field !== "whatsapp" && field !== "email" && field !== "phone") {
        empityFields.push(field)
      }
    })

    if (empityFields.length !== 0) {
      this.setState({ requiredAlert: empityFields })
      submit = false
    }

    if (phone.trim() === "" && email.trim() === "" && whatsapp.trim() === "") {
      this.setState({
        phoneOrWhatsappOrMailMessage: true
      })
      submit = false
    } else {
      this.setState({
        phoneOrWhatsappOrMailMessage: false
      })
    }

    if (email.trim() !== "") {
      if (!/\S+@\S+\.\S+/.test(email)) {
        this.setState({ invalidEmail: true })
        submit = false
      }
      else this.setState({ invalidEmail: false })
    }

    if (!submit || this.state.invalidPhone || this.state.invalidWhatsapp) return

    _service({
      method: 'POST',
      url: "/remote/contact",
      data: {
        name, phone, whatsapp, email,
        session_uid: this.props.data ? this.props.data.uid : ''
      },
      success: (response) => {
        if (response.json) {
          this.setState({ loading: false, submitted: true, phoneIsWhatsapp: true, phone: "", whatsapp: "", name: "", email: "", isModalVisible: false, phoneOrWhatsappOrMailMessage: true, requiredAlert: ["name"] });
        }
      },
      fail: (e) => {
        console.error("Service /remote/config failed.", e);
        this.setState({ loading: false, error: true });
      }
    });
  }

  handleModalShow() {
    this.setState({ isModalVisible: true, error: false, submitted: false, loading: false });
  }

  handleModalHide() {
    this.setState({ isModalVisible: false });
  }

  render() {
    const { name, phone, whatsapp, email, loading, submitted, error, isModalVisible, requiredAlert } = this.state;
    let content = null;
    if (loading) {
      content = (
        <Loading />
      );
    } else if (submitted) {
      content = (
        Core.notification({
          title: 'OBRIGADO',
          type: 'success',
          message: "Submetido com sucesso, brevemente entraremos em contacto."
        })
      );
    } else if (error) {
      content = (
        <p>Não foi possível submeter os dados, por favor tente mais tarde ou entre em contacto diretamente.</p>
      );
    } else {
      content = (
        <form>
          <label>
            Nome
            <input type="text" name="name" value={name} onChange={this.handleInputChange} />
            {requiredAlert.indexOf("name") !== -1 ? <span className="alert">Campo obrigatório.</span> : null}
          </label>
          <label>
            Telemóvel
            <input maxLength={15} type="text" name="phone" value={phone} onChange={this.handleInputChange} />
            {this.state.invalidPhone ? <span className="alert">Telefone inválido.</span> : null}
            {this.state.phoneOrWhatsappOrMailMessage ? <span className="alert">Preencha o telefone, o whatsapp ou o e-mail</span> : null}
          </label>
          <label>
            WhatsApp
            <input maxLength={15} type="text" name="whatsapp" value={this.state.phoneIsWhatsapp ? phone : whatsapp} onChange={this.handleInputChange} />
            {this.state.phoneOrWhatsappOrMailMessage ? <span className="alert">Preencha o whatsapp, o telefone ou o e-mail</span> : null}
            {this.state.invalidWhatsapp ? <span className="alert">WhatsApp inválido.</span> : null}
          </label>
          <label>
            E-mail
            <input type="text" name="email" value={email} onChange={this.handleInputChange} />
            {this.state.phoneOrWhatsappOrMailMessage ? <span className="alert">Preencha o e-mail, o telefone ou o whatsapp</span> : null}
            {this.state.invalidEmail && requiredAlert.indexOf("email") === -1 ? <span className="alert">Digite um e-mail válido.</span> : null}
          </label>
          <button type="button" onClick={this.handleSubmit}>Enviar</button>
        </form>
      );
    }
    let modal = null;
    if (isModalVisible) {
      modal = (
        <div className="contact-form__modal" onClick={(e) => {
          if (isModalVisible) {
            this.setState({ isModalVisible: false });
          }
        }}>
          <div className="contact-form__modal__content" onClick={e => {
            e.stopPropagation()
          }}>
            <span className="contact-form__modal__close" onClick={this.handleModalHide}>&times;</span>
            <h1>Solicitar contacto</h1>
            {content}
            {!error && !submitted ? (
              <div className="contact-form__modal__footer">
                <p><img src="./icons/phone.png" alt="phone" /><a href={`tel:${this.props.phone}`}>{this.props.formattedPhone}</a></p>
                <p><img src="./icons/email.png" alt="email" /><a href={`mailto:${this.props.email}`}>{this.props.email}</a></p>
              </div>
            ) : null}
          </div>
        </div>
      );
    } else if (!isModalVisible && submitted) {
      modal = content;
    }
    return (
      <div className="contact-form">
        {modal}
        {this.props.data && (
          <button onClick={this.handleModalShow}>
            <img src="./icons/contact.png" alt="" />
          </button>
        )}
      </div>
    );
  }
}
